"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=(e,t=0)=>(...i)=>{typeof e=="function"&&requestAnimationFrame(()=>setTimeout(()=>e(...i),t))};exports.yieldCallback=o;
//# sourceMappingURL=yield-callback.cjs.map
